export default "__VITE_ASSET__DAVjwQOG__"